import type { ViewFieldsFragment } from '@salescore/client-api'
import { selectViewQueryResult, useAppSelector } from '@salescore/client-redux'
import type { ViewQueryResult } from '@salescore/core'

export const useViewQueryResult = (view: ViewFieldsFragment): ViewQueryResult | undefined =>
  useAppSelector((state) => selectViewQueryResult(state, { viewId: view.id }))
